"use client";

import { useEffect, useState } from "react";
import { usePathname } from "next/navigation";
import { Toaster as Sonner, ToasterProps } from "sonner";
import { isPlacePathname } from '@/lib/routing/place-href';

const Toaster = ({ ...props }: ToasterProps) => {
  const pathname = usePathname();
  const isPublicMenu = isPlacePathname(pathname);
  const [tourActive, setTourActive] = useState(false);

  useEffect(() => {
    if (typeof document === "undefined") return;

    const sync = () => {
      setTourActive(document.body.dataset.tourActive === "true");
    };

    sync();

    const observer = new MutationObserver(sync);
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ["data-tour-active"],
    });

    return () => observer.disconnect();
  }, []);

  return (
    <Sonner
      theme="light"
      position={isPublicMenu ? "top-center" : undefined}
      toastOptions={{ closeButtonAriaLabel: "Dismiss notification" }}
      className={`toaster group ${tourActive ? "pointer-events-none opacity-0" : ""}`}
      style={
        {
          "--normal-bg": "hsl(var(--popover))",
          "--normal-text": "hsl(var(--popover-foreground))",
          "--normal-border": "hsl(var(--border))",
          transition: "opacity 120ms ease",
        } as React.CSSProperties
      }
      {...props}
    />
  );
};

export { Toaster };
